import React from 'react'

import { Button, ModalBox, Skeleton, useModalContext } from '@fourthwall/components'

import type { useMemberQuery } from '../../hooks/useMemberQuery'

type Props = {
  member: NonNullable<ReturnType<typeof useMemberQuery>['memberQuery']['data']>
}

export const RefundModalSkeleton = ({ member }: Props) => {
  const modal = useModalContext()

  return (
    <ModalBox
      title={<>Refund {member.nickname}</>}
      size="medium"
      buttons={[
        <Button label="Close" appearance="secondary" onClick={modal.close} />,
        <Button label="Refund" appearance="destructive" loading />,
      ]}
      onClose={modal.close}
    >
      <Skeleton gap={16}>
        <Skeleton.Shape width={225} height={24} />
        <Skeleton gap={10}>
          <Skeleton.Shape width="100%" height={48} />
          <Skeleton.Shape width="100%" height={48} />
          <Skeleton.Shape width="100%" height={48} />
        </Skeleton>
      </Skeleton>
    </ModalBox>
  )
}
